import { gql } from "@apollo/client";

export const TOLL_FREE_REGISTRATION_FIELDS_FOR_LIST = gql`
  fragment TollFreeRegistrationFields on TollFreeRegistration {
    id
    tenantId
    subaccount {
      id
      slug
    }
    organizationName
    orgType
    createdBy {
      email
    }
    createdAt
    submissionStatus
  }
`;

export const TOLL_FREE_REGISTRATION_STAFF_FIELDS = gql`
  fragment TollFreeRegistrationStaffFields on TollFreeRegistration {
    id
    tenant {
      id
      slug
    }
    subaccount {
      id
      slug
    }
    organizationName
    orgType
    displayName
    address1
    address2
    city
    state
    postalCode
    country
    website
    contactFirstName
    contactLastName
    contactEmail
    contactPhone
    orgContactIsPrimaryContact
    primaryContactFirstName
    primaryContactLastName
    primaryContactEmail
    primaryContactPhone
    messageVolume
    additionalContext
    notes
    requestedTnCount

    useCase
    useCaseSummary
    productionMessageContent
    usageStartDate
    usageTypes

    optInWorkflowDescription
    optInWorkflowImageUrls
    optInPageUrl
    privacyPolicyUrl
    termsAndConditionsUrl
    createComplianceBundle
    acknowledgedCompliance

    createdBy {
      email
    }

    submissionStatus

    inventoryPhoneNumbers {
      id
      phoneNumber
      state
      provisioningState
      tollFreeVerificationRequests {
        id
        bandwidthTicketNumber
        status
        declineReason
      }
    }
  }
`;

export const LIST_ALL_TOLL_FREE_REGISTRATIONS = gql`
  ${TOLL_FREE_REGISTRATION_FIELDS_FOR_LIST}
  query ListAllTollFreeRegistrations(
    $input: ListAllTollFreeRegistrationsInput!
  ) {
    listAllTollFreeRegistrations(input: $input) {
      ...TollFreeRegistrationFields
    }
  }
`;

export const GET_TOLL_FREE_REGISTRATION = gql`
  ${TOLL_FREE_REGISTRATION_STAFF_FIELDS}
  query GetTollFreeRegistration($input: GetTollFreeRegistrationInput!) {
    getTollFreeRegistration(input: $input) {
      ...TollFreeRegistrationStaffFields
    }
  }
`;

export const CREATE_TOLL_FREE_REGISTRATION = gql`
  mutation CreateTollFreeRegistration(
    $input: CreateTollFreeRegistrationInput!
  ) {
    createTollFreeRegistration(input: $input) {
      id
    }
  }
`;

export const LIST_TOLL_FREE_REGISTRATIONS = gql`
  query ListTollFreeRegistrations($input: ListTollFreeRegistrationsInput!) {
    listTollFreeRegistrations(input: $input) {
      id
      organizationName
      submissionStatus
      createdAt
      createdBy {
        id
        fullName
      }
    }
  }
`;

export const STAFF_SEARCH_TOLL_FREE_REGISTRATIONS = gql`
  ${TOLL_FREE_REGISTRATION_FIELDS_FOR_LIST}
  query StaffSearchTollFreeRegistrations(
    $input: StaffSearchTollFreeRegistrationsInput!
  ) {
    staffSearchTollFreeRegistrations(input: $input) {
      registrations {
        ...TollFreeRegistrationFields
      }
      totalCount
    }
  }
`;

export const EDIT_TOLL_FREE_REGISTRATION = gql`
  mutation EditTollFreeRegistration($input: EditTollFreeRegistrationInput!) {
    editTollFreeRegistration(input: $input) {
      id
    }
  }
`;

export const SUBMIT_TOLL_FREE_REGISTRATION_TO_BANDWIDTH = gql`
  mutation SubmitTollFreeRegistrationToBandwidth(
    $input: SubmitTollFreeRegistrationToBandwidthInput!
  ) {
    submitTollFreeRegistrationToBandwidth(input: $input) {
      id
    }
  }
`;

export const DELETE_TOLL_FREE_REGISTRATION = gql`
  mutation DeleteTollFreeRegistration(
    $input: DeleteTollFreeRegistrationInput!
  ) {
    deleteTollFreeRegistration(input: $input) {
      success
    }
  }
`;

export const COPY_TOLL_FREE_REGISTRATION = gql`
  ${TOLL_FREE_REGISTRATION_STAFF_FIELDS}
  mutation CopyTollFreeRegistration($input: CopyTollFreeRegistrationInput!) {
    copyTollFreeRegistration(input: $input) {
      ...TollFreeRegistrationStaffFields
    }
  }
`;
